<template>
  <section id="radios">
    <div class="demo">
      <div class="row">
        <div class="col-md-6">
          <h5>Default</h5>
          <p>
            <code>.radio-primary</code>,
            <code>.radio-danger</code>
          </p>
          <div class="radio radio-primary">
            <input type="radio" name="radio1" id="radio1" value="option1" checked="">
            <label for="radio1">
              Small
            </label>
          </div>
          <div class="radio radio-primary">
            <input type="radio" name="radio1" id="radio2" value="option2">
            <label for="radio2">
              Big
            </label>
          </div>
          <div class="radio radio-danger">
            <input type="radio" name="radio2" id="radio3" value="option1">
            <label for="radio3">
              Next
            </label>
          </div>
          <div class="radio radio-danger">
            <input type="radio" name="radio2" id="radio4" value="option2" checked="">
            <label for="radio4">
              One
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <h5>Disabled</h5>
          <div class="radio radio-primary">
            <input type="radio" name="radio3" id="radio5" value="option1" disabled="">
            <label for="radio5">
              Disabled
            </label>
          </div>
          <div class="radio radio-primary">
            <input type="radio" name="radio3" id="radio6" value="option2" checked="" disabled="">
            <label for="radio6">
              Disabled Checked
            </label>
          </div>
          <h5 class="mt-5">Inline radios</h5>
          <div class="radio radio-primary radio-inline">
            <input type="radio" id="inlineRadio1" value="option1" name="radioInline" checked="">
            <label for="inlineRadio1">
              Inline One
            </label>
          </div>
          <div class="radio radio-primary radio-inline">
            <input type="radio" id="inlineRadio2" value="option2" name="radioInline">
            <label for="inlineRadio2">
              Inline Two
            </label>
          </div>
        </div>
      </div>   
    </div>  
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/forms/radios.md";
export default {
  name: "radios",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.form.radios.name);
    this.$emit("update-tagline", this.$root.yamlData.form.radios.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
